import { useDispatch, useSelector } from "react-redux";
import { fetchAllLaneAsync } from "../redux/features/driverMaster";

const useTrip = () => {
   const dispatch = useDispatch();

   // Reuse lanes already cached in Redux — no duplicate local state
   const laneForTrip = useSelector((state) => state.driverMaster.laneMaster ?? []);

   const laneForTripApiCall = () => {
      dispatch(
         fetchAllLaneAsync({
            done: () => {},
            err: () => {},
         }),
      );
   };

   return {
      laneForTrip,
      laneForTripApiCall,
   };
};

export default useTrip;
